<!-- <div class="w3-col m8 w3-container w3-margin-bottom info-container2 w3-center w3-hover-shadow w3-borderB"> -->
  <p class="mt-3" style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;"><b>The details of
      the projects submitted to GoI, MoWR for approval and inclusion under ISBIG are as under:-
    </b></p>

  <table class="w3-border" style="border-collapse:separate; margin-left:40px; width:90%;">
    <tr>
      <th>Sr.No.</th>
      <th>Name of Projects</th>
      <th>Physical Target(CCA in Ha.)</th>
      <th>
        Estimated cost of the Project(Rs. in lakh)</th>
      <th>Districts to be covered</th>
    </tr>
    <tr>
      <th colspan=5>A On-going Projects</th>
    </tr>
    <tr>
      <td>1</td>
      <td>BCC-II </td>
      <td>1,07,675 </td>
      <td>72984.18 </td>
      <td>Hisar, Sirsa,
        Fatebahad, Ambala, Kaithal, Kanal, Kurukshetra &amp; Jind</td>
    </tr>
    <tr>
      <td>2</td>
      <td>WJC-VI</td>
      <td>73,144</td>
      <td>49238.55</td>
      <td>
        Hisar, Rohtak, Jhajjar, Sonepat, Jind, Bhiwani &amp; Panipat</td>
    </tr>
    <tr>
      <td>3</td>
      <td>JLN-II</td>
      <td>88,704</td>
      <td>59495.00</td>
      <td>Jhajjar,
        Rewari, Mehandergarh, Bhiwani &amp; Gurgaon</td>
    </tr>
    <tr>
      <th colspan=5>B New Projects</th>
    </tr>
    <tr>
      <td>4</td>
      <td>BCC-III</td>
      <td>1,71,852</td>
      <td>111141.06</td>
      <td>Hisar,
        Sirsa, Fatebahad, Ambala, Kaithal, Kanal, Kurukshetra &amp; Jind</td>
    </tr>
    <tr>
      <td>
        5</td>
      <td>WJC-VII</td>
      <td>75,341</td>
      <td>49567.71</td>
      <td>Hisar, Rohtak,
        Jhajjar, Sonepat, Jind, Bhiwani &amp; Panipat</td>
    </tr>
    <tr>
      <td>6</td>
      <td>Siwani Project </td>
      <td>49,899</td>
      <td>31834.95</td>
      <td>
        Bhiwani</td>
    </tr>
    <tr>
      <td colspan=2>Total</td>
      <td>5,66,615</td>
      <td>374261.45</td>
      <td>NA</td>
    </tr>
  </table><br>
<!-- </div> -->